import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  forwardRef,
  Output,
  EventEmitter,
  Renderer2,
  OnChanges,
  SimpleChanges,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { Calendar } from 'primeng/calendar';

/**
 * Date picker component wrapped around primeng calendar component
 */
@Component({
  selector: 'app-ui-calendar',
  templateUrl: './ui-calendar.component.html',
  styleUrls: ['./ui-calendar.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiCalendarComponent),
      multi: true,
    },
  ],
})
export class UiCalendarComponent implements ControlValueAccessor, OnInit, OnChanges {
  /**
   * list of days to be disabled
   */
  @Input() disabledDays = [];

  /**
   * getter for value
   */
  @Input()
  get value(): Date {
    return this._value;
  }

  /**
   * setter for value
   */
  set value(value: Date) {
    if (value !== this._value) {
      this._value = value;

      this.onChange.forEach((fn) => {
        if (typeof fn === 'function') {
          try {
            fn(value);
          } catch (e) {}
        }
      });
    }
  }

  /**
   * constructor to inject dependency
   * @param renderer instance of renderer
   * @param element instance of element
   */
  constructor(private renderer: Renderer2, private element: ElementRef, private host: ElementRef) {}

  /**
   * date form control
   */
  date: UntypedFormControl;

  /**
   * indicate if control will be readonly
   */
  @Input() isReadOnly = false;

  /**
   * indicate if control will be disabled
   */
  @Input() disabled = false;

  /**
   * year range
   */
  @Input() yearRange = '2000 : 2030';

  /**
   * indicate if date control is invalid
   */
  @Input() isInvalid: ValidationErrors | boolean;

  /**
   * input element
   */
  private input: HTMLInputElement;

  /**
   * reference of calendar control
   */
  @ViewChild(Calendar) private _calendar: Calendar;

  /**
   * output touch event
   */
  @Output() touchEvent = new EventEmitter<any>();

  /**
   * change event
   */
  @Output() public changeEvent = new EventEmitter();

  /**
   * input field value
   */
  _inputFieldValue;

  /**
   * on change function
   */
  private onChange = [(_: Date) => {}];

  /**
   * value
   */
  private _value: Date = undefined;

  /**
   * on touch function
   */
  private onTouch: any = () => {};

  /**
   * initialize component
   */
  ngOnInit() {
    this.yearRange = `2000 : ${new Date().getFullYear() + 10}`;
  }

  /**
   * on user entering the date in textbox
   * @param event event
   */
  onInput(event) {
    this._calendar.onUserInput(event);
  }

  /**
   * on blur event on the component
   * @param event touch event
   */
  onBlur(event) {
    this.onTouch();
  }

  /**
   * write date to the component
   * @param obj dateValue
   */
  writeValue(obj: any): void {
    this.value = obj;
  }

  /**
   * register on change function
   * @param fn change function
   */
  registerOnChange(fn: any): void {
    this.onChange.push(fn);
  }

  /**
   * register on touch function
   */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  /**
   * set control to disabled state
   * @param isDisabled is controls disabled
   */
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.renderer.setAttribute(this.element.nativeElement, 'disabled', isDisabled.toString());
  }

  /**
   * on changes event
   */
  ngOnChanges(changes: SimpleChanges) {}

  /**
   * bind input blur
   */
  onInputBlur = ((e) => {
    console.log(e.target.value);
    this._calendar.onUserInput(e);
    console.log('blur');
  }).bind(this);

  /**
   * emit date change
   */
  dateChange() {
    if(this._value){
    this.changeEvent.emit(this._value);
    }
  }

  /**
   * format the date entered as mm/dd/yyyy
   */
  formatDate(event) {
    //this.dateChange();
     if (!isNaN(event.data)) {
       if (event.target.value.length === 10 && !event.target.value.includes("_")) {
         this.dateChange();
       }
     }
  }
}
